import { render, staticRenderFns } from "./HomePart6.vue?vue&type=template&id=fb724fe0&scoped=true&"
import script from "./HomePart6.vue?vue&type=script&lang=js&"
export * from "./HomePart6.vue?vue&type=script&lang=js&"
import style0 from "./HomePart6.vue?vue&type=style&index=0&id=fb724fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb724fe0",
  null
  
)

export default component.exports